"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCIAL_MEDIA_SERVICES = void 0;
exports.SOCIAL_MEDIA_SERVICES = [
    "facebook",
    "instagram",
    "youtube",
    "twitter",
    "tiktok",
    "bandcamp",
    "linkinbio",
    "merch",
    "website",
];
//# sourceMappingURL=Wizard.js.map